import { Button, Modal, message, Spin } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Urls, { postRequest } from "../../../services/common/urls";
import { AddMachine, DeleteMachine, ExecuteQuery, GetStatus } from "../../../services/common/cnc_apis";
import { SettingOutlined } from "@ant-design/icons";
import lang from "../../../services/lang";
import MachineManageDialog from "./MachineManageDialog/MachineManageDialog";
import "./MachineSettings.css";
import MachineTable from "./MachineTable/MachineTable";
import * as actionType from "../../../services/redux/actionType";

function MachineSettings(props) {
  const { langIndex } = useSelector((state) => state.app);
  const authData = useSelector((x) => x.authService);
  const { security_level } = authData;
  
  const {
    showModal,
    setShowModal,
    selCustomerId,
    machineList,
    setMachineInfoList,
    setMachineList,
    dispatch,
  } = props;

  const [isShowModal, setIsShowModal] = useState(false);
  const [initMachineInfo, setInitMachineInfo] = useState(null);
  const [isBusy, setBusy] = useState(false);

  const onClickEditRecord = (record) => {
    setInitMachineInfo(record);
    setIsShowModal(true);
  };

  const onClickAddMachine = () => {
    setInitMachineInfo(null);
    setIsShowModal(true);
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const addMachine = (machineInfo) => {
    // Security level check
    if (Number(security_level) !== 4) {
      message.error(lang(langIndex, "msg_permission_denied") || "Permission denied. Admin access required.");
      return;
    }
    
    // selCustomerId
    machineInfo["customer_id"] = selCustomerId;
    var id =
      machineList.length == 0
        ? 1
        : Math.max.apply(
            Math,
            machineList.map(function (o) {
              return o.id;
            })
          ) + 1;

    machineInfo["id"] = id;

    AddMachine(machineInfo, (res) => {
      if (res == null) return;
      if (res.status == true) {
        var newItem = { ...machineInfo, key: machineInfo.id };
        
        newItem.order = machineList.length == 0
        ? 1
        : Math.max.apply(
            Math,
            machineList.map(function (o) {
              return o.order;
            })
          ) + 1;
        
        let newMachineList = [...machineList, newItem];
        setMachineList(newMachineList);
        message.success(lang(langIndex, "msg_update_success"));
        setIsShowModal(false);
        setMachineInfoList(newMachineList);
      } else {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    });

    // Add machine to the tbl_app_setting
    var param = {
      customer_id: selCustomerId,
      machine_id: machineInfo.machine_id,
      detail: {
        factory_id: selCustomerId,
        machine_id: machineInfo.machine_id,
        device_id: machineInfo.device_id,
      },
    };
    postRequest(Urls.UPDATE_APP_SETTING, param, (res) => {});
  };

  const moveMachine = (machineInfo, dir) => {
    // Security level check
    if (Number(security_level) !== 4) {
      message.error(lang(langIndex, "msg_permission_denied") || "Permission denied. Admin access required.");
      return;
    }
    
    /*let position = parseInt(machineInfo.order);
    if (dir == -1 && position > 1) {
      let query1 =
        "UPDATE " +
        "`" +
        selCustomerId +
        "_status` " +
        "SET " +
        "`order`=" +
        "'" +
        position +
        "' WHERE `order`='" +
        (position - 1) +
        "'";
      setBusy(true);
      ExecuteQuery(query1, (res) => {
        let query2 =
          "UPDATE " +
          "`" +
          selCustomerId +
          "_status` " +
          "SET " +
          "`order`=" +
          "'" +
          (position - 1) +
          "' WHERE `id`='" +
          machineInfo.id +
          "'";
        ExecuteQuery(query2, (res) => {
          setBusy(false);
        });
      });

      let newMachineList = [...machineList];
      newMachineList[position - 2].order = position;
      newMachineList[position - 1].order = position - 1;
      newMachineList.sort((a, b) => a.order - b.order);
      setMachineList(newMachineList);
    }

    if (dir == 1 && position < machineList.length) {
      let query =
        "UPDATE " +
        "`" +
        selCustomerId +
        "_status` " +
        "SET " +
        "`order`=" +
        "'" +
        position +
        "' WHERE `order`='" +
        (position + 1) +
        "'";
      setBusy(true);
      ExecuteQuery(query, (res) => {
        query =
          "UPDATE " +
          "`" +
          selCustomerId +
          "_status` " +
          "SET " +
          "`order`=" +
          "'" +
          (position + 1) +
          "' WHERE `id`='" +
          machineInfo.id +
          "'";
        ExecuteQuery(query, (res) => {
          setBusy(false);
        });
      });

      let newMachineList = [...machineList];
      newMachineList[position].order = position;
      newMachineList[position - 1].order = position + 1;
      newMachineList.sort((a, b) => a.order - b.order);
      setMachineList(newMachineList);
    }*/

    // When moving, swap the `order` values between the selected item and the target item (not using index arithmetic).
    // Find the target machine to swap with based on current discrete order values.
    let position = parseInt(machineInfo.order);

    // Find index of current machine in the list
    let currentIdx = machineList.findIndex(m => m.id === machineInfo.id);

    // If direction is up (-1)
    if (dir == -1) {
      // Find the machine with the next lower order value
      let lowerMachines = machineList.filter(m => parseInt(m.order) < position);
      if (lowerMachines.length === 0) return; // Already at top
      let maxLowerOrder = Math.max(...lowerMachines.map(m => parseInt(m.order)));
      let targetMachine = machineList.find(m => parseInt(m.order) === maxLowerOrder);
      if (!targetMachine) return;

      // Swap the orders in the database
      let query1 =
        "UPDATE `" +
        selCustomerId +
        "_status` SET `order`='" +
        position +
        "' WHERE `id`='" +
        targetMachine.id +
        "'";
      let query2 =
        "UPDATE `" +
        selCustomerId +
        "_status` SET `order`='" +
        maxLowerOrder +
        "' WHERE `id`='" +
        machineInfo.id +
        "'";
      setBusy(true);
      ExecuteQuery(query1, res => {
        ExecuteQuery(query2, res2 => {
          setBusy(false);
        });
      });

      // Swap the orders locally
      let newMachineList = machineList.map(m => {
        if (m.id === machineInfo.id) {
          return { ...m, order: maxLowerOrder };
        }
        if (m.id === targetMachine.id) {
          return { ...m, order: position };
        }
        return m;
      });
      newMachineList.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      setMachineList(newMachineList);

      return;
    }

    // If direction is down (+1)
    if (dir == 1) {
      // Find the machine with the next higher order value
      let higherMachines = machineList.filter(m => parseInt(m.order) > position);
      if (higherMachines.length === 0) return; // Already at bottom
      let minHigherOrder = Math.min(...higherMachines.map(m => parseInt(m.order)));
      let targetMachine = machineList.find(m => parseInt(m.order) === minHigherOrder);
      if (!targetMachine) return;

      // Swap the orders in the database
      let query1 =
        "UPDATE `" +
        selCustomerId +
        "_status` SET `order`='" +
        position +
        "' WHERE `id`='" +
        targetMachine.id +
        "'";
      let query2 =
        "UPDATE `" +
        selCustomerId +
        "_status` SET `order`='" +
        minHigherOrder +
        "' WHERE `id`='" +
        machineInfo.id +
        "'";

      setBusy(true);
      ExecuteQuery(query1, res => {
        ExecuteQuery(query2, res2 => {
          setBusy(false);
        });
      });

      // Swap the orders locally
      let newMachineList = machineList.map(m => {
        if (m.id === machineInfo.id) {
          return { ...m, order: minHigherOrder };
        }
        if (m.id === targetMachine.id) {
          return { ...m, order: position };
        }
        return m;
      });
      newMachineList.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      setMachineList(newMachineList);
      return;
    } 
  };

  const editMachine = (machineInfo) => {
    // Security level check
    if (Number(security_level) !== 4) {
      message.error(lang(langIndex, "msg_permission_denied") || "Permission denied. Admin access required.");
      return;
    }
    
    const newData = [...machineList];
    const index = newData.findIndex((item) => item.key === machineInfo.key);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...machineInfo });
      const newItem = newData[index];
      let query1 =
        "UPDATE " +
        "`" +
        selCustomerId +
        "_status` " +
        "SET " +
        "`machine_id`='" +
        newItem.machine_id +
        "', " +
        "`machine_picture_url`='" +
        newItem.machine_picture_url +
        "' " +
        "WHERE `id`='" +
        newItem.id +
        "'";

      let query2 =
        "UPDATE " +
        "`buffer_ganttdata` " +
        "SET " +
        "`machine_id`='" +
        newItem.machine_id +
        "' WHERE `machine_id`='" +
        item.machine_id +
        "' AND `customer_id`='" +
        selCustomerId +
        "'";

      ExecuteQuery(query1, (res) => {
        ExecuteQuery(query2, (res) => {
          var param = {
            customer_id: selCustomerId,
            machine_id: item.machine_id,
            detail: {
              factory_id: selCustomerId,
              machine_id: newItem.machine_id,
              device_id: newItem.device_id,
            },
          };
          postRequest(Urls.UPDATE_APP_SETTING, param, (res) => {});
        });
      });

      setMachineInfoList(newData);
      setMachineList(newData);
      message.success(lang(langIndex, "msg_update_success"));
      setIsShowModal(false);
    } else {
      message.error(lang(langIndex, "msg_something_wrong"));
    }
  };

  const deleteMachine = (machineInfo) => {
    // Security level check
    if (Number(security_level) !== 4) {
      message.error(lang(langIndex, "msg_permission_denied") || "Permission denied. Admin access required.");
      return;
    }

    // Ant Design Modals do not support a built-in 'dark' theme via a prop.
    // To set the Modal (and its confirm dialog) to dark theme, you need to:
    // 1. Install and use the Ant Design dark theme (less variables or CSS),
    // 2. Or override styles in your CSS,
    // 3. Or, if using Ant Design v5+, use the ConfigProvider with 'theme' set to 'dark'.

    // Example: Using ConfigProvider (Ant Design v5+)
    // import { ConfigProvider } from 'antd';
    // <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}>
    //   ...your app
    // </ConfigProvider>

    // But for just Modal.confirm, you can set a className and override its style:
    Modal.confirm({
      title: lang(langIndex, "msg_confirm_delete"),
      content: lang(langIndex, "msg_delete_machine_warning") || "",
      okText: lang(langIndex, "ok") || "OK",
      okType: "danger",
      cancelText: lang(langIndex, "cancel") || "Cancel",
      // Add a custom class
      className: "custom-dark-modal",
      onOk() {
        DeleteMachine({customer_id: selCustomerId, machine_id: machineInfo.machine_id }, (res) => {
          if (res == null) return;
          if (res.status == true) {
            const newMachineList = machineList.filter(m => m.id !== machineInfo.id);
            setMachineList(newMachineList);
            message.success(lang(langIndex, "msg_update_success"));
            setMachineInfoList(newMachineList);
          } else {
            message.error(lang(langIndex, "msg_something_wrong"));
          }
        });
      },
      onCancel() {
        // No action needed on cancel
      },
    });
    
  };

  return (
    <Modal
      centered
      visible={showModal}
      title={null}
      onCancel={() => onCancel()}
      onOk={() => onCancel()}
      closable={true}
      className="customer-setting-dialog-style"
      destroyOnClose={true}
      width={700}
      footer={null}
    >
      <div className="customer-setting-page-title">
        <SettingOutlined />
        <span style={{ marginLeft: 10 }} />
        {lang(langIndex, "plant_machinesetting")}
      </div>

      <div
        className="content-scrollbar-style user-setting-container"
        style={{ overflow: "auto" }}
      >
        {isShowModal === true && (
          <MachineManageDialog
            initMachineInfo={initMachineInfo}
            addMachine={addMachine}
            editMachine={editMachine}
            isShowModal={isShowModal}
            setIsShowModal={setIsShowModal}
          />
        )}
        <div className="user-setting-button-container">
          <Button
            ghost
            onClick={() => {
              onClickAddMachine();
            }}
          >
            {lang(langIndex, "plant_addmachine")} +{" "}
          </Button>
        </div>
        <div className="user-setting-user-table-style">
          <Spin spinning={isBusy}>
            <MachineTable
              machineList={machineList}
              onClickEditRecord={onClickEditRecord}
              moveMachine={moveMachine}
              deleteMachine={deleteMachine}
            />
          </Spin>
        </div>
      </div>
    </Modal>
  );
}

export default MachineSettings;
